// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"2756247f","289":"18559a69","318":"c6f73250","352":"acc51762","722":"c9319211"}[chunkId] + ".chunk.js";
};